import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class OlFeatureFlagsService {
  constructor(
    private firestore: AngularFirestore,
    private authService: AuthService
  ) {}

  private get docPath(): string {
    return `empresaMae/${this.authService.dominioId}/ol_config/feature_flags`;
  }

  getShowPdfProposalPreview$(): Observable<boolean> {
    return this.firestore
      .doc(this.docPath)
      .get()
      .pipe(map((snap) => !!snap.get('showPdfProposalPreview')));
  }
}
